import { render } from "./Filters.vue?vue&type=template&id=18fac1c4&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=18fac1c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-18fac1c4"

export default script